import { render, staticRenderFns } from "./Black.vue?vue&type=template&id=2e78ba14"
import script from "./Black.vue?vue&type=script&lang=js"
export * from "./Black.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports